import {Pipe, PipeTransform} from '@angular/core';
import { checkJsonObject, replaceCitations, sanitizeJson } from '@core/utils';

@Pipe({
    name: 'chatQuestions',
    standalone: false
})
export class ChatQuestions implements PipeTransform{
    transform(value: string): [] {
        return sanitizeJson(value)?.questions ?? [];
        
    }
}
